var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconExitLeft = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M11.25 4.5C11.664 4.5 12 4.836 12 5.25C12 5.664 11.664 6 11.25 6H6C5.586 6 5.25 6.336 5.25 6.75V17.25C5.25 17.664 5.586 18 6 18H11.25C11.664 18 12 18.336 12 18.75C12 19.164 11.664 19.5 11.25 19.5H6C4.75725 19.5 3.75 18.4928 3.75 17.25V6.75C3.75 5.50725 4.75725 4.5 6 4.5H11.25Z", fill: "black" }),
            React.createElement("path", { d: "M13.2803 14.4699L11.5605 12.7501H19.5C19.914 12.7501 20.25 12.4141 20.25 12.0001C20.25 11.5861 19.914 11.2501 19.5 11.2501H11.5605L13.2803 9.53036C13.5728 9.23786 13.5728 8.76236 13.2803 8.46986C12.9878 8.17736 12.5123 8.17736 12.2198 8.46986L9.21976 11.4699C8.92726 11.7624 8.92726 12.2379 9.21976 12.5304L12.2198 15.5304C12.5123 15.8229 12.9878 15.8229 13.2803 15.5304C13.5728 15.2379 13.5728 14.7624 13.2803 14.4699Z", fill: "black" }))),
        alt: 'Icon ExitLeft',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconExitLeft;
//# sourceMappingURL=index.js.map